import React from "react";
import {
  Box,
  Card,
  CardBody,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
} from "@chakra-ui/react";

const ImpressionsTable = ({ isLoading, data, formatNumber }) => {
  return (
    <Card
      width={{ base: "100%", md: "500px" }}
      mx="auto"
      boxShadow="lg"
      borderRadius="lg"
    >
      <CardBody>
        <Heading size="md" textAlign="center" color="gray.700" fontSize={14}>
          Impressions Per Website
        </Heading>
        <Text color="gray.400" textAlign="center" mb={4} fontSize={12}>
          Estimated Potential Audience Reach.
        </Text>

        {isLoading ? (
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            gap={6}
            height={"100%"}
            p={6}
          >
            <span class="loader"></span>
            <Text color="colorPalette.600">Loading...</Text>
          </Flex>
        ) : (
          <TableContainer>
            <Table variant="striped" colorScheme="gray" size="sm">
              <Thead bgColor="gray.100">
                <Tr>
                  <Th fontWeight="semibold" color="gray.600" fontSize="14px">
                    Website
                  </Th>
                  <Th fontWeight="semibold" color="gray.600" fontSize="14px">
                    Impressions
                  </Th>
                </Tr>
              </Thead>
              <Tbody maxH={'500px'} overflowY={'auto'}>
                {data?.map((item, index) => (
                  <Tr key={index}>
                    <Td
                      borderBottom="1px solid #E2E8F0"
                      fontSize="12px"
                      color="gray.700"
                    >
                      {item?.appOrSiteDomain}
                    </Td>
                    <Td borderBottom="1px solid #E2E8F0" fontSize="12px">
                      {formatNumber(item?.auctions)}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default ImpressionsTable;
